import React from "react";
import { Helmet } from "react-helmet";
import ResourcesCommonComponent from "./ResourcesCommonComponent";
import { resourcesServices } from "../../services/resourcesService";
import { defer } from "react-router-dom";

const BloodBanks = () => {
  return (
    <div>
      <Helmet>
        <title>Donate At Your Nearby Blood Bank - Cope With Cancer</title>

        <meta
          name="description"
          content="Want to donate blood and save a life but don't know the blood banks nearby? Cope with cancer has listed some blood banks near you."
        />
        <meta name="robots" content="index,nofollow,noodp" />
        <link
          rel="canonical"
          href="https://www.copewithcancer.org/blood-banks"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Donate At Your Nearby Blood Bank - Cope With Cancer"
        />
        <meta
          property="og:description"
          content="Want to donate blood and save a life but don't know the blood banks nearby? Cope with cancer has listed some blood banks near you."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/blood-banks"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="Want to donate blood and save a life but don't know the blood banks nearby? Cope with cancer has listed some blood banks near you."
        />
        <meta
          name="twitter:title"
          content="Donate At Your Nearby Blood Bank - Cope With Cancer"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-06-06T10:05:53+00:00" />
      </Helmet>

      <div className="topspace">
        <div className="text-center">
          <div className="bloodbank"><div className="bannertitleNew mediabannertitleNew">Blood Banks</div></div>
          {/* <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/bloodbank_banner-300x59.jpg" alt="What is Cancer" className="w-100"></img> */}
          <h1 className="bannertitle displayNone">Blood Banks</h1>
        </div>
        <div className="contentBox">
          <div className="container">
            <h3 className="Bold28 mb20">Blood Banks</h3>

            <ResourcesCommonComponent senderComponent="BloodBanks" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default BloodBanks;

const getResource = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : "?pageNumber=1&city=mumbai&state=maharashtra&location";
    console.log(searchParams);
    const resource = "bloodBanks";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getResources(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return {
      resources: responce.data.ResponseObject,
      totalRecords: responce.data.TotalRecords,
    };
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getLocation = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : null;
    console.log(searchParams);
    const resource = "bloodBanks";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getLocations(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return responce.data.ResponseObject;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const loader = async ({ request, params }) => {
  return defer({
    data: await getResource({ request, params }),
    locations: await getLocation({ request, params }),
  });
};
